import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

export const AnalyticsTab = ({ stats, formAnalytics }) => {
  const steps = [
    { step: 1, label: 'Stap 1: Postcode', count: formAnalytics?.step_1 || 0 },
    { step: 2, label: 'Stap 2: Type & Adres', count: formAnalytics?.step_2 || 0 },
    { step: 3, label: 'Stap 3: Huidige Provider', count: formAnalytics?.step_3 || 0 },
    { step: 4, label: 'Stap 4: Diensten & Naam', count: formAnalytics?.step_4 || 0 },
    { step: 5, label: 'Stap 5: Contactgegevens', count: formAnalytics?.step_5 || 0 },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="w-5 h-5" />
            Formulier Analytics
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold mb-4">Formulier Abandonment per Stap</h3>
              <p className="text-sm text-slate-600 mb-4">
                Hoeveel bezoekers stoppen bij elke stap van het formulier
              </p>

              {formAnalytics ? (
                <div className="space-y-4">
                  {steps.map(({ step, label, count }) => {
                    const total = formAnalytics.total_abandonments || 1;
                    const percentage = total > 0 ? Math.round((count / total) * 100) : 0;

                    return (
                      <div key={step} className="space-y-1">
                        <div className="flex justify-between text-sm">
                          <span>{label}</span>
                          <span className="font-medium">{count} ({percentage}%)</span>
                        </div>
                        <div className="w-full bg-slate-200 rounded-full h-2">
                          <div
                            className="bg-blue-600 h-2 rounded-full transition-all"
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                      </div>
                    );
                  })}

                  <div className="mt-6 p-4 bg-slate-50 rounded-lg">
                    <div className="text-sm text-slate-600">
                      <strong>Totaal abandonments:</strong> {formAnalytics.total_abandonments || 0}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-slate-500">
                  Nog geen analytics data beschikbaar.
                </div>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Conversie Statistieken</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="p-4 bg-blue-50 rounded-lg text-center">
              <div className="text-2xl font-bold text-blue-700">{stats.total_leads || 0}</div>
              <div className="text-sm text-blue-600">Totaal Leads</div>
            </div>
            <div className="p-4 bg-yellow-50 rounded-lg text-center">
              <div className="text-2xl font-bold text-yellow-700">{stats.new_leads || 0}</div>
              <div className="text-sm text-yellow-600">Nieuwe Leads</div>
            </div>
            <div className="p-4 bg-green-50 rounded-lg text-center">
              <div className="text-2xl font-bold text-green-700">{stats.converted_leads || 0}</div>
              <div className="text-sm text-green-600">Klanten</div>
            </div>
            <div className="p-4 bg-purple-50 rounded-lg text-center">
              <div className="text-2xl font-bold text-purple-700">{stats.conversion_rate || 0}%</div>
              <div className="text-sm text-purple-600">Conversie</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
